module.exports = __webpack_public_path__ + "static/img/__1576.34211bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1576.jpg
// module id = 5XGx
// module chunks = 0